import fly from "../../fly/fly";

export const updateViewport = (map, newViewport) => {
    if (newViewport.fly) {
        fly(map, newViewport.value);
    }
} 